module.exports = __webpack_public_path__ + "img/tip_play.09ab5a75.png";